import * as React from "react";
import { County, State } from "@app/geography";
import { Link } from "react-router-dom";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { breadcrumbTemplates, BreadcrumbTemplateEnum } from "@app/shared/breadcrumbs/breadcrumbTemplates";
import Page from "@app/shared/Page";
import PageHeader from "@app/shared/PageHeader";
import PageHeaderLeft from "@app/shared/PageHeaderLeft";
import PageHeaderRight from "@app/shared/PageHeaderRight";
import PageInner from "@app/shared/PageInner";
import PageSection from "@app/shared/PageSection";
import Breadcrumbs from "@app/shared/breadcrumbs/Breadcrumbs";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";
import GeographyService from "@app/geography/geographyService";

interface StateDetailsProps {
  states: State[];
}

interface StatePaneState {
  activeState?: State;
  counties: County[];
}

export default class GeoLookupStateView extends React.Component<StateDetailsProps, StatePaneState> {
  private readonly geographyService = new GeographyService();
  private readonly breadcrumbs = breadcrumbTemplates[BreadcrumbTemplateEnum.SearchState];
  constructor(props: StateDetailsProps) {
    super(props);

    this.state = {
      counties: [],
    };
  }

  public async componentDidMount() {
    if (this.props.states && this.props.states.length) {
      this.refreshStateItems(this.state.activeState || this.props.states[0]);
    }
  }

  public async componentDidUpdate(prevProps: StateDetailsProps) {
    if (prevProps.states !== this.props.states) {
      this.refreshStateItems(this.state.activeState || this.props.states[0]);
    }
  }

  public render() {
    let countiesList;
    if (this.state.activeState) {
      countiesList = this.state.counties.map((county) =>
        <li className="mtb5 plr10" key={county.name}><Link to={`/tools/lookupcounty/${county.state}/${county.countySSA}`}>{county.name}</Link></li>,
      );
    }

    return (
      <>
        {(this.state.activeState) && (
          <Page documentTitle="Lookup a State">
            <Breadcrumbs items={this.breadcrumbs} />
            <PageInner>
              <PageHeader title={this.state.activeState.name} disableHR={true} iconName={QesIcons.SearchSm}>
                <PageHeaderLeft>
                  <span className="geolookup-subtitle">{this.state.activeState.abbreviation}</span>
                </PageHeaderLeft>
                <PageHeaderRight>
                  <div className="page-title-bar">
                    <div className="ms-auto">
                      <QESSelect label="State" hideLabel={true} testId="geolookup-state__state" className="form-control lookup-state-option mb-3 mb-md-0" value={this.state.activeState.abbreviation} onChange={this.handleStateChange}>
                        {!this.props.states || this.props.states.length === 0 && (<option>Loading...</option>)}
                        {this.props.states.map((state) => (
                          <option key={state.abbreviation} value={state.abbreviation}>{state.name}</option>
                        ))}
                      </QESSelect>
                    </div>
                  </div>
                </PageHeaderRight>
              </PageHeader>
              <PageSection>
                <div className="row">
                  <div className="col-12 col-sm-4">
                    <div className="card card-expansion-item card-static">
                      <div className="card-header">State Details</div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-12">
                            <p><span><img className="state-flag-img" src={`${window.customUIBaseUrl}/images/StateFlags/${this.state.activeState.abbreviation}.png`} /></span></p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <p><strong>SSA:</strong> {this.state.activeState.stateSSA}</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <p><strong>FIPS:</strong> {this.state.activeState.stateFIPS}</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <p><strong>Area:</strong> {this.state.activeState.area} mi<sup>2</sup></p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <div className="row">
                              <div className="col-12">
                                <strong>Extents:</strong>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-12">
                                <em className="ps-3">Minimum Latitude:</em> {this.state.activeState.minLatitude}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-12">
                                <em className="ps-3">Minimum Longitude:</em> {this.state.activeState.minLongitude}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-12">
                                <em className="ps-3">Maximum  Latitude:</em> {this.state.activeState.maxLatitude}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-12">
                                <p className="ps-3"><em>Maximum  Longitude:</em> {this.state.activeState.maxLongitude}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <div className="row">
                              <div className="col-12">
                                <strong>Centroid:</strong>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-12">
                                <em className="ps-3">Latitude:</em> {this.state.activeState.centroidLatitude}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-12">
                                <p className="ps-3"><em>Longitude:</em> {this.state.activeState.centroidLongitude}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <div className="row">
                              <div className="col-12">
                                <strong>Label:</strong>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-12">
                                <em className="ps-3">Latitude:</em> {this.state.activeState.labelLatitude}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-12">
                                <em className="ps-3">Longitude:</em> {this.state.activeState.labelLongitude}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-8">
                    <div className="card card-expansion-item card-static">
                      <div className="card-header">Counties</div>
                      <div className="card-body">
                        <ul className="multi-column list-unstyled mb0 columns-xs-2 columns-sm-3 columns-md-4 columns-lg-5">
                          {countiesList}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </PageSection>
            </PageInner>
          </Page>
        )}
      </>
    );
  }

  private async refreshStateItems(active: State) {
    const activeState = active;
    const states = this.props.states;
    const counties = await this.geographyService.getCountiesByState(activeState.abbreviation);
    this.setState((prevState) => ({ ...prevState, activeState, counties, states }));
  }

  private handleStateChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const abbreviation = e.target.value;
    const activeState = this.props.states.find((s) => s.abbreviation === abbreviation);
    this.refreshStateItems(activeState);
  }
}

export { GeoLookupStateView };
